/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 27684:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   r: () => (/* binding */ SvgIconFill)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconFill = function SvgIconFill(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m419.57-481 170.21 170.22q11.83 11.82 11.33 27.78t-12.33 27.78q-11.82 11.83-28.28 11.83t-28.28-11.83L334.78-452.65q-6.13-6.13-9.26-13.39-3.13-7.26-3.13-14.96 0-7.7 3.13-14.96 3.13-7.26 9.26-13.39l198.44-198.43q11.82-11.83 28.28-11.83t28.28 11.83q11.83 11.82 11.83 28.28t-11.83 28.28L419.57-481Z"
  })));
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 -960 960 960\"><path d=\"m419.57-481 170.21 170.22q11.83 11.82 11.33 27.78t-12.33 27.78q-11.82 11.83-28.28 11.83t-28.28-11.83L334.78-452.65q-6.13-6.13-9.26-13.39-3.13-7.26-3.13-14.96 0-7.7 3.13-14.96 3.13-7.26 9.26-13.39l198.44-198.43q11.82-11.83 28.28-11.83t28.28 11.83q11.83 11.82 11.83 28.28t-11.83 28.28L419.57-481Z\"/></svg>");

/***/ }),

/***/ 46242:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   r: () => (/* binding */ SvgIcon)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m419.57-481 170.21 170.22q11.83 11.82 11.33 27.78t-12.33 27.78q-11.82 11.83-28.28 11.83t-28.28-11.83L334.78-452.65q-6.13-6.13-9.26-13.39-3.13-7.26-3.13-14.96 0-7.7 3.13-14.96 3.13-7.26 9.26-13.39l198.44-198.43q11.82-11.83 28.28-11.83t28.28 11.83q11.83 11.82 11.83 28.28t-11.83 28.28L419.57-481Z"
  })));
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 -960 960 960\"><path d=\"m419.57-481 170.21 170.22q11.83 11.82 11.33 27.78t-12.33 27.78q-11.82 11.83-28.28 11.83t-28.28-11.83L334.78-452.65q-6.13-6.13-9.26-13.39-3.13-7.26-3.13-14.96 0-7.7 3.13-14.96 3.13-7.26 9.26-13.39l198.44-198.43q11.82-11.83 28.28-11.83t28.28 11.83q11.83 11.82 11.83 28.28t-11.83 28.28L419.57-481Z\"/></svg>");

/***/ }),

/***/ 58387:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   defaultIconProps: () => (/* binding */ defaultIconProps)
/* harmony export */ });

const defaultIconProps = {
  width: 20,
  height: 20,
  fill: "currentColor",
  variant: "filled"
};


/***/ }),

/***/ 99497:
/***/ ((module) => {

module.exports = require("react");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ChevronLeft: () => (/* binding */ ChevronLeft),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99497);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _svg_ChevronLeft_icon_fill_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27684);
/* harmony import */ var _svg_ChevronLeft_icon_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46242);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58387);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};




const name = "chevron_left";
function ChevronLeft(props) {
  const _a = __spreadValues(__spreadValues({}, _common__WEBPACK_IMPORTED_MODULE_3__.defaultIconProps), props), { variant } = _a, restProps = __objRest(_a, ["variant"]);
  const IconComponent = variant === "outlined" ? _svg_ChevronLeft_icon_svg__WEBPACK_IMPORTED_MODULE_2__/* .ReactComponent */ .r : _svg_ChevronLeft_icon_fill_svg__WEBPACK_IMPORTED_MODULE_1__/* .ReactComponent */ .r;
  const overrides = props.size ? { width: props.size, height: props.size } : {};
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0___default().createElement(IconComponent, __spreadValues(__spreadValues({ "aria-label": name }, restProps), overrides));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ChevronLeft);

})();

module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=index.js.map